import { useDispatch } from "react-redux";
import {
  GetOptions,
  CreateOptions,
  DeleteOptions,
  CreatePreOptions,
  UpdateOption,
} from "../api/services/options";
import { useToast } from "./useToast";
import { setOptionsData, setOptionsList } from "../reducer/tourReducer";
import { toast } from "react-toastify";
import { CreatePackageOptionsProps } from "../declarations/tourServices";
import { PackageOptionsProps } from "../types/data";

export function useOptions() {
  const dispatch = useDispatch();
  const { showResponseMessages } = useToast();

  const getOptions = async (query: any) => {
    let response;
    try {
      response = await GetOptions(query);
      const { status, errors, message, options } = response;
      if (status === 200) {
        dispatch(setOptionsList(options || []));
      } else {
        showResponseMessages(status, message, errors);
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      throw error;
    }
    return (
      response || {
        status: 500,
        options: [],
        errors: ["Unknown error"],
        message: "Failed to fetch options",
      }
    );
  };

  const getOptionsById = async (id: string) => {};

  const createOptions = async (payload: PackageOptionsProps) => {
    try {
      const response = await CreateOptions(payload);
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const createPreOptions = async (payload: PackageOptionsProps) => {
    // Clean payload before sending
    let cleanedPayload = { ...payload };
    if (cleanedPayload.pricingOption === "fixed") {
      delete cleanedPayload.pricingCategories;
      delete cleanedPayload.pricePerAgeGroup;
      delete cleanedPayload.groupPricing;
      delete cleanedPayload.pricing;
    }
    try {
      const response = await CreatePreOptions(cleanedPayload);
      console.log("create pre options response", payload);
      const { message, status, errors } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const deleteOptions = async (id: string) => {
    try {
      const response = await DeleteOptions(id);
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const updateOption = async (id: string, payload: any): Promise<any> => {
    try {
      const response = await UpdateOption({ id, payload });
      console.log("response updatePackage", response);
      const { message, status, errors } = response;
      if (status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in updatePackage:", error);
      throw error;
    }
  };

  return {
    getOptions,
    createOptions,
    deleteOptions,
    createPreOptions,
    updateOption,
  };
}
